export default __webpack_public_path__ + "images/TE.3fefe2b.png";